import { apiClient } from '../utils/api-client';
import type { LeaderboardEntry, LeaderboardGender } from '../types/leaderboard';

interface LeaderboardResponse {
  data: {
    id: string;
    type: 'gym_leaderboard';
    attributes: { entries: LeaderboardEntry[] };
  };
}

class LeaderboardService {
  /** `gender` narrows the table to that gender, with the same gym-wide points. */
  async getGymLeaderboard(gymSlugOrId: string, gender?: LeaderboardGender): Promise<LeaderboardEntry[]> {
    const query = gender ? `?gender=${gender}` : '';
    const response = await apiClient.get(`/api/gyms/${gymSlugOrId}/leaderboard${query}`);

    if (!response.ok) {
      throw new Error('Failed to fetch leaderboard');
    }

    const data: LeaderboardResponse = await response.json();
    return data.data.attributes.entries;
  }
}

export const leaderboardService = new LeaderboardService();
